import React, { useContext } from 'react'
import css from "./order.module.scss"
import { AuthContext } from "../../../context/auth";
import { useNavigate } from 'react-router-dom';
import { removeLocalStorage } from '../../../helpers/localStorage';



export const OrderCompleteModal = () => {
  const { setCompleteOrderModal, setCompletedOrderData, completedOrderData, setCartData, tempDisable } = useContext(AuthContext)
  const navigate = useNavigate()

  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <span className={css.closeIcon} onClick={() => {
            setCompleteOrderModal(false)
            setCompletedOrderData(null)
            setCartData(null)
            removeLocalStorage('cartId')
            navigate('/')
          }}>
            <i className='fas fa-times' />
          </span>
          <span className={css.icon}>
            <i class="far fa-check"></i>
          </span>
        </div>
        <h2 style={{ marginBottom: '5px' }}>Thank you for your Order! </h2>
        <h5 style={{ marginBottom: '12px' }}>Order <span style={{ fontWeight: '700' }}>#{completedOrderData}</span></h5>
        <p style={{ marginBottom: '20px' }}>Your order has been successfully placed. We will send you an email once your order has been shipped.</p>
        <button className={`btn ${css.ctaBtn}`} onClick={() => {
          setCompleteOrderModal(false)
          setCompletedOrderData(null)
          setCartData(null)
          removeLocalStorage('cartId')
          navigate('/')
        }}>Continue Shopping</button>
        <button className={css.link} onClick={() => {
          setCompleteOrderModal(false)
          setCompletedOrderData(null)
          setCartData(null)
          removeLocalStorage('cartId')
          navigate('/profile/orders')
        }}>View Order</button>
      </div>
    </div>
  )
}